import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Input from '../../../../../../common/ui/Input/input';
import {
  Body, BodyContainer, InputBox, KeyboardContainer, NextButton,
} from '../../utils/style';
import Keyboard from '../common/keyboard';
import {
  resetTicket, setTextError, setConfirmText,
} from '../../../store/actions';
import Store from '../../../store/store';

const { dispatch } = Store;

function EmulatePreRecord({ children }) {
  const { style, config } = useSelector((state) => state);
  const navigate = useNavigate();

  const {
    id, headUrl, errorUrl, confirmUrl,
  } = config;
  const [pin, setPin] = useState('');
  const [inputId, setId] = useState('input');

  const { title, button, input } = style;

  // Лев просил, чтобы кнопки были ТАКОГО же цвета
  const changeInputStyle = {
    ...input,
  };

  const item = {
    name: '',
    params: {
      fid: 'input',
      value: 'number',
    },
  };

  const clickInput = (value) => setId(value);

  const onNext = () => {
    const RULE = !((+pin - 1) % 12);
    if (RULE) {
      dispatch(setConfirmText('Пин-код подтвержден!'));
      localStorage.setItem('emulatePreRecord', pin);
      navigate(confirmUrl);
      setTimeout(() => {
        navigate(`${headUrl}/${id}/print`);
      }, 3000);
    } else {
      navigate(errorUrl);
      dispatch(setTextError('По введенному пинкоду не найдена предварительная запись на сегодня.'));
      dispatch(resetTicket());
    }
  };

  return (
    <BodyContainer style={style.body}>
      <Body>
        <div style={title}>Введите пин-код</div>
        <KeyboardContainer height>
          <InputBox button={button} style={{ flex: 0, margin: '30px 0' }}>
            <Input
              item={item}
              height={70}
              style={changeInputStyle}
              width="50%"
              value={pin}
              id={inputId}
              clickInput={clickInput}
            />
          </InputBox>
          <Keyboard
            styleButton={button}
            setValue={(e) => setPin(e)}
            value={pin}
            id={inputId}
          />
        </KeyboardContainer>
        {pin.length >= 4
          && (
          <NextButton
            style={{
              ...style.bottomButton,
            }}
            onClick={onNext}
          >
            Готово
          </NextButton>
          )}
      </Body>
      {children}
    </BodyContainer>
  );
}

export default EmulatePreRecord;
